<template>
  <div id="loading-spinner">
    <div class="spinner-border text-primary" role="status"/>
    <div>Loading...</div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #3498DB;
  min-height: 100vh;
}

#loading-spinner div {
  margin-top: 10px
}
</style>
